<script>
import ChargemapCaption from "../../../global/ChargemapCaption.vue";
import PoolRating from "../../../rating/PoolRating.vue";
import DrawerInfoCard from "./DrawerInfoCard.vue";
export default {
  name: "DrawerInfoNetwork",
  components: {
    DrawerInfoCard,
    PoolRating,
    ChargemapCaption
  },
  props: {
    pool: {
      type: Object,
      default: void 0
    }
  },
  emits: ["goToNetwork"],
  computed: {
    getNetworkName() {
      return this.pool?.network?.name || "";
    },
    getNetworkGlobalRating() {
      return this.pool?.network?.averageRating || 0;
    }
  }
};
</script>

<template>
    <div class="flex flex-col gap-1">
        <DrawerInfoCard>
            <template #title>
                {{ $t("word.network") }}
            </template>
            <button
                type="button"
                class="w-full flex flex-row text-sky-600 justify-between items-center"
                @click="$emit('goToNetwork')"
            >
                <div
                    class="grow shrink basis-0 flex-col justify-start items-start inline-flex"
                >
                    <div class="self-stretch text-base text-left leading-tight">
                        {{ getNetworkName }}
                    </div>
                </div>
                <IconChevronRight class="size-6" />
            </button>
            <div>
                <PoolRating
                    :rating="getNetworkGlobalRating"
                    size="extra-small"
                    text-size="font-medium"
                />
            </div>
        </DrawerInfoCard>
        <ChargemapCaption class="px-1">
            <template #icon>
                <IconInfoCircle class="size-3" is-solid />
            </template>
            {{ $t("tab_info.network.caption") }}
        </ChargemapCaption>
    </div>
</template>
